import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { Plus, Trash2 } from 'lucide-react';

export default function AssetsStep({ form, updateForm, addPersonToList }) {
    function add() {
        updateForm({ assets: [...form.assets, { id: String(Date.now()), asset_type: 'other', description: '', estimated_value: 0 }] });
    }
    
    function update(i, f, v) {
        const a = [...form.assets];
        a[i] = { ...a[i], [f]: v };
        updateForm({ assets: a });
    }
    
    function remove(i) {
        updateForm({ assets: form.assets.filter((_, j) => j !== i) });
    }

    return React.createElement('div', { className: 'space-y-6' },
        React.createElement('div', { className: 'flex items-center justify-between' },
            React.createElement('h3', { className: 'font-serif text-lg' }, 'Assets'),
            React.createElement(Button, { type: 'button', variant: 'outline', size: 'sm', onClick: add, className: 'rounded-none', 'data-testid': 'add-asset-btn' },
                React.createElement(Plus, { className: 'h-4 w-4 mr-2' }),
                'Add Asset'
            )
        ),
        form.assets.length === 0 
            ? React.createElement('p', { className: 'text-muted-foreground text-sm' }, 'No assets added yet')
            : form.assets.map((asset, i) => 
                React.createElement('div', { key: asset.id, className: 'p-4 border border-stone-200 space-y-4' },
                    React.createElement('div', { className: 'flex justify-between' },
                        React.createElement('span', { className: 'text-sm font-medium' }, 'Asset ' + (i + 1)),
                        React.createElement(Button, { type: 'button', variant: 'ghost', size: 'icon', onClick: () => remove(i), className: 'text-destructive h-8 w-8' },
                            React.createElement(Trash2, { className: 'h-4 w-4' })
                        )
                    ),
                    React.createElement('div', { className: 'grid grid-cols-1 md:grid-cols-3 gap-4' },
                        React.createElement('div', { className: 'space-y-2' },
                            React.createElement(Label, null, 'Type'),
                            React.createElement(Input, { value: asset.asset_type, onChange: e => update(i, 'asset_type', e.target.value), className: 'rounded-none' })
                        ),
                        React.createElement('div', { className: 'space-y-2' },
                            React.createElement(Label, null, 'Description'),
                            React.createElement(Input, { value: asset.description, onChange: e => update(i, 'description', e.target.value), className: 'rounded-none' })
                        ),
                        React.createElement('div', { className: 'space-y-2' },
                            React.createElement(Label, null, 'Value ($)'),
                            React.createElement(Input, { type: 'number', value: asset.estimated_value, onChange: e => update(i, 'estimated_value', parseFloat(e.target.value) || 0), className: 'rounded-none' })
                        )
                    )
                )
            )
    );
}
